module.exports = __webpack_public_path__ + "static/media/amex.95870026.svg";